/* Solicitudes (Hostelking) — envío AJAX de los formularios de "bajo pedido" y "avísame cuando haya stock".
   Intercepta cualquier <form data-solicitud>, hace POST al endpoint de captura y muestra el éxito inline.
   Sin recarga de página. Un solo listener delegado (seguro aunque el snippet se incluya dos veces). */
(function () {
  if (window.__solicitudesInit) return;
  window.__solicitudesInit = true;

  var ENDPOINT = 'https://e09olrymsl.execute-api.eu-west-1.amazonaws.com/production/captura';

  function post(form) {
    var params = new URLSearchParams();
    new FormData(form).forEach(function (value, key) { params.append(key, value); });
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: params.toString(),
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, body: j }; });
    });
  }

  // Botón "Avísame" (sin sesión): despliega el campo de email y oculta el botón.
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest ? e.target.closest('[data-aviso-toggle]') : null;
    if (!toggle) return;
    var form = toggle.closest('form[data-solicitud]');
    if (!form) return;
    var panel = form.querySelector('[data-aviso-panel]');
    if (panel) panel.hidden = false;
    toggle.hidden = true;
    var email = form.querySelector('input[type="email"]');
    if (email) email.focus();
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-solicitud]')) return;
    e.preventDefault();

    var fields = form.querySelector('[data-fields]');
    var okEl = form.querySelector('[data-ok]');
    var errEl = form.querySelector('[data-err]');
    var btn = form.querySelector('[type="submit"]');
    if (errEl) errEl.hidden = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }

    post(form).then(function (res) {
      if (res.status === 200 && res.body && res.body.ok) {
        if (fields) fields.hidden = true;
        if (okEl) okEl.hidden = false;
      } else {
        var msg = (res.body && res.body.errors && res.body.errors.join('. ')) ||
                  'No se pudo enviar. Inténtalo de nuevo en un momento.';
        if (errEl) { errEl.textContent = msg; errEl.hidden = false; }
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      }
    }).catch(function () {
      if (errEl) { errEl.textContent = 'Error de conexión. Inténtalo de nuevo.'; errEl.hidden = false; }
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    });
  });

  // ── Mini-carrusel de productos relacionados (cuando sale "avísame") ──
  function money(cents) {
    return (Number(cents) / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  function imgUrl(u, w) {
    if (!u) return '';
    if (u.indexOf('//') === 0) u = 'https:' + u;
    return u + (u.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s || ''; return d.innerHTML; }

  // Arrastre con ratón para el carrusel ("grab & scroll"); en táctil se usa el scroll nativo.
  function enableDragScroll(el) {
    var down = false, startX = 0, startScroll = 0, moved = false, pid = null;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); }); // sin drag nativo de img/enlace
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      down = true; moved = false; startX = e.clientX; startScroll = el.scrollLeft; pid = e.pointerId;
      try { el.setPointerCapture(pid); } catch (_) {} // el drag sigue aunque el ratón salga de la zona
      el.classList.add('aviso-related__track--drag');
    });
    el.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = true;
      el.scrollLeft = startScroll - dx;
      e.preventDefault();
    });
    function up() { if (!down) return; down = false; el.classList.remove('aviso-related__track--drag'); try { el.releasePointerCapture(pid); } catch (_) {} }
    el.addEventListener('pointerup', up);
    el.addEventListener('pointercancel', up);
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    // Rueda del ratón por encima del carrusel → scroll horizontal (deja pasar al llegar a los extremos).
    el.addEventListener('wheel', function (e) {
      if (el.scrollWidth <= el.clientWidth) return;
      var d = e.deltaY;
      if (!d) return;
      var atStart = el.scrollLeft <= 0;
      var atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
      if ((d < 0 && atStart) || (d > 0 && atEnd)) return;
      el.scrollLeft += d;
      e.preventDefault();
    }, { passive: false });
  }

  // Precio con la MISMA estructura del tema (.price__default/.price__current/.price__was) para que
  // el sistema IVA de la web lo procese igual que las cards: modo activo primero + el otro debajo,
  // y siguiendo el toggle con/sin IVA. Valores CON IVA (el sistema deriva el sin IVA ÷1,21).
  function priceHtml(price, compare) {
    var was = (compare && compare > price) ? '<s class="price__was">' + money(compare) + '</s>' : '';
    return '<strong class="price__current">' + money(price) + '</strong>' + was;
  }

  function initRelated() {
    var box = document.querySelector('[data-related-for]');
    if (!box) return;
    var pid = box.getAttribute('data-related-for');
    fetch('/recommendations/products.json?product_id=' + pid + '&intent=related&limit=12')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var prods = (data.products || []).filter(function (p) { return p.available && String(p.id) !== String(pid); });
        if (!prods.length) return;
        var cards = prods.map(function (p) {
          return '<a class="aviso-related__card" href="' + p.url + '">' +
            '<img class="aviso-related__img" src="' + imgUrl(p.featured_image, 300) + '" alt="" loading="lazy">' +
            '<span class="aviso-related__title">' + esc(p.title) + '</span>' +
            '<div class="price__default aviso-related__price theme-money">' + priceHtml(p.price, p.compare_at_price) + '</div>' +
            '</a>';
        }).join('');
        box.innerHTML = '<div class="aviso-related__head">Alternativas disponibles</div>' +
          '<div class="aviso-related__track">' + cards + '</div>' +
          '<div class="aviso-related__bar"><span class="aviso-related__bar-thumb"></span></div>';
        var track = box.querySelector('.aviso-related__track');
        var bar = box.querySelector('.aviso-related__bar');
        var thumb = box.querySelector('.aviso-related__bar-thumb');
        if (track) {
          enableDragScroll(track);
          var updateBar = function () {
            var overflow = track.scrollWidth - track.clientWidth;
            bar.style.display = overflow > 2 ? '' : 'none';
            var w = Math.max(15, (track.clientWidth / track.scrollWidth) * 100);
            var pos = overflow > 0 ? (track.scrollLeft / overflow) : 0;
            thumb.style.width = w + '%';
            thumb.style.left = (pos * (100 - w)) + '%';
          };
          track.addEventListener('scroll', updateBar);
          window.addEventListener('resize', updateBar);
          updateBar();
        }
      })
      .catch(function () {});
  }
  initRelated();
})();
